import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";

// import { state, mutations, actions } from './mutations'

// Este es el archivo base de todo el manejo de Vuex
// Mi recomendación es que se lea toda la documentación de vuex antes de arrancar a tocar este
// código. Toda la documentación es corta y se puede leer rapidamente
// https://vuex.vuejs.org/

// Voy a comentar el archivo assessment, los otros archivos funcionan de forma parecida

import userAccount from "./modules/userAccount";
import business from "./modules/business";
import assessment from "../components/modules/self-assesment/store/assessment";
import advancedReports from "./modules/advancedReports";
import lang from "./modules/lang";
import invitation from "./modules/invitation";
import opinionSurvey from "./modules/opinionSurvey";
import indicator from "./modules/indicator";
import pillar from "./modules/pillar";
import evaluation from "../components/modules/evaluation/store/evaluation";
import adminTables from "../components/modules/administration/store/adminTables";
import error from "./modules/error";
import loadPanel from "./modules/loadPanel";
import newDashboard from "./../components/modules/new-dashboard/store/new-dashboard.store.js";
import trackerDashboard from "./../components/modules/tracker-dashboard/store/tracker-dashboard.store";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    userAccount,
    business,
    assessment,
    advancedReports,
    lang,
    invitation,
    opinionSurvey,
    indicator,
    pillar,
    evaluation,
    adminTables,
    error,
    loadPanel,
    newDashboard,
    trackerDashboard
  },
  strict: debug,
  // state,
  // mutations,
  // actions,

  plugins: [createPersistedState({
    storage: window.sessionStorage,
    paths: [
      'userAccount',
      'assessment',
      'business',
      'advancedReports',
      'lang',
      'invitation',
      'opinionSurvey',
      'indicator',
      'pillar',
      'evaluation',
      'adminTables',
      'error',
      'newDashboard'
    ]
  })], // TODO Test storage with cookies see --> https://www.npmjs.com/package/vuex-persistedstate
});
